import { cva } from '@/styled-system/css';

export const propertyCardPhotoFallbackRecipe = cva({
  base: {
    'position': 'absolute',
    'insetInlineStart': '50%',
    'insetBlockStart': '50%',
    'transform': 'translate3d(-50%, -50%, 0)',

    '& > .c11n-property-card-fallback-fill': {
      fill: 'PropertyCard.PhotoFallback.icon',
    },
  },
  variants: {
    appearance: {
      large: {
        blockSize: 'icon.xxl',
        inlineSize: 'icon.xxl',
      },
      small: {
        blockSize: 'icon.xl',
        inlineSize: 'icon.xl',
      },
      horizontal: {
        blockSize: 'icon.xl',
        inlineSize: 'icon.xl',
      },
    },
  },
});
